export const REGEX_MAP = {
    amountCharsOnly: /^([0-9]+)?(\.)?([0-9]+)?$/,
    amountCharsOnlyWith2DecimalMax: /^\d*(\.)?(\d{1,2})?$/,
    numberOnly: /^\d*$/,
    englishOnly: /^[A-Za-z0-9 _/.,']*$|^$/,
    positiveAmount: /^\d{0,13}(\.\d{1,3})?$/,
    durationIndicator: /^$|^\d+(?:\.\d{0,2})?(?:m(?:i|o)?|h|d|w)?$/,
};
